import React, { useState, useEffect, useContext } from 'react'
import styled from 'styled-components'
import { Row, Col, Progress, Pagination, Tooltip, Modal, Form, Checkbox } from 'antd'
import more from '../../../icons/More.svg'
import imgDefault from '../../../icons/Ellipse1.svg'
import {
  UserOutlined,
  CalendarOutlined,
  InboxOutlined,
  ExclamationCircleOutlined,
  CloseCircleOutlined,
  ExceptionOutlined,
} from '@ant-design/icons'
import { Menu, Dropdown } from 'antd'
import { getSearchCardlist } from '../../../api/projectList'
import ModalCopy from 'common/Project/modalCopy'
import { useHistory } from 'react-router-dom'
import { getCookie, removeCookie, setCookie } from 'helper/cookie'
import { deleteProject } from 'api/Project/project'
import 'styleLess/signature/projectlist.scss'
import moment from 'moment'
import loadingSvg from 'icons/robot1.svg'
import loadingAnimationSvg from 'icons/three-dots.svg'
import lang from 'lang/en'
import { CounterContext } from 'redux/Golbalvalues'
import TextSeeMore from 'common/textSeeMore.component'
import { projectCancel, projectHold, projectSkip } from 'api/Project/status'
import TextArea from 'antd/lib/input/TextArea'
import Swal from 'sweetalert2'
import { getFileSecurityFromApi } from 'api/OpenFile'
const style = { background: '#white' }

const Container = styled.div`
  width: 100%;
  // min-height: 88vh;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  flex-direction: column;
  align-items: flex-start;

  .AreaPagination {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
  }
`
const color = {
  no_procent: '#f5f5f5',
  percent_0: '#f5f5f5',
  percent_50: '#FF6258',
  percent_75: '#FFAF00',
  percent_100: '#19D895',
}

const initalState = {
  data: [],
  isLoading: true,
  limit: 12,
  page: 1,
  totalRecord: 1,
  current: 1,
}

const CardListComponents = (props) => {
  const { setPathActive } = useContext(CounterContext)
  const { dataSearch, permission, roleUser, receivedData } = props
  const history = useHistory()
  const [form_cancel] = Form.useForm()
  const [form_hold] = Form.useForm()
  const [form_cancelApprove] = Form.useForm()
  const [data, setData] = useState(initalState.data)
  const [totalRecord, setTotalRecord] = useState(initalState.totalRecord)
  const [totalPage, setTotalPage] = useState('')
  const token = getCookie('access_token_admin')
  const [waiting, setWaiting] = useState(true)
  const [visibleModalCopy, setVisibleModalCopy] = useState(false)
  const [idProject, setIdProject] = useState()
  const [visibleModalDelete, setVisibleModalDelete] = useState(false)
  const [render, setRender] = useState(1)
  const [currentPagination, setCurrentPagination] = useState(initalState.page)
  const [openModalCancleProject, setOpenModalCancleProject] = useState(false)
  const [openModalHoldProject, setOpenModalHoldProject] = useState(false)
  const [openModalCancleApprovalProject, setOpenModalCancleApprovalProject] = useState(
    false,
  )
  const [idProjectSelectMoer, setIdProjectSelectMoer] = useState()
  const [inCase3, setInCase3] = useState(false)
  const [check, setCheck] = useState('y')
  const [valueCheck, setValueCheck] = useState(true)

  const [dataSearchURL, setDataSearchURL] = useState({
    start_date: '',
    end_date: '',
    company_id: '',
    operation_id: '',
    suboperation_id: '',
    project_group_id: '',
    subproject_group_id: '',
    impact_type_id: '',
    status_id: '',
    searchvalue: '',
  })
  const queryParam = new URLSearchParams(window.location.search)

  const [dataList, setDataList] = useState([])

  useEffect(() => {
    const fetchData = async () => {
      const results = await Promise.all(
        data?.map(async (item) => {
          if (item?.logo !== null) {
            const response = await getFileSecurityFromApi({
              url: item?.logo[0]?.urlfile,
              token,
            })
            const { data } = response
            const blobUrl = URL.createObjectURL(data)
            return { ...item, pic_display: blobUrl } // หรือจะเลือกใช้ property ที่คุณต้องการจาก API ก็ได้
          } else {
            return { ...item, pic_display: item.pic_display } // หรือจะเลือกใช้ property ที่คุณต้องการจาก API ก็ได้
          }
        }),
      )
      setDataList(results)
    }

    fetchData()
  }, [data])

  useEffect(() => {
    setDataSearchURL((prevState) => ({
      ...prevState,
      start_date: queryParam.get('start_date'),
      end_date: queryParam.get('end_date'),
      company_id: queryParam.get('company_id'),
      operation_id: queryParam.get('operation_id'),
      suboperation_id: queryParam.get('suboperation_id'),
      project_group_id: queryParam.get('project_group_id'),
      subproject_group_id: queryParam.get('subproject_group_id'),
      impact_type_id: queryParam.get('impact_type_id'),
      status_id: queryParam.get('status_id'),
      searchvalue: queryParam.get('searchvalue'),
      // ondelay: queryParam.get('ondelay'),
    }))
  }, [])

  useEffect(() => {
    //เข้าจังหวะแรก url เดิม
    if (token) {
      if (window.location.href.split('/')[3] == 'project-list') {
      }
    }
  }, [token])

  useEffect(() => {
    //search จังหวะแรก url เดิม
    if (window.location.href.split('/')[3] == 'project-list') {
      if (props.dataSearch != '') {
        SearchCardlist(1)
        setCurrentPagination(1)
      }
    }
  }, [props])

  useEffect(() => {
    //มาจาก dashboard ไม่มีการ search
    if (window.location.href.split('/')[3] != 'project-list') {
      if (dataSearchURL.start_date != '') {
        SearchCardlist(2)
      }
    }
  }, [dataSearchURL])

  useEffect(() => {
    //มาจาก dashboard มีการ search
    if (window.location.href.split('/')[3] != 'project-list') {
      if (props.dataSearch != '') {
        setInCase3(true)
        setCurrentPagination(1)
        SearchCardlist(3)
      }
    }
  }, [props.dataSearch])

  useEffect(() => {
    if (window.location.href.split('/')[3] == 'project-list' && !inCase3) {
      SearchCardlist(4)
      setCurrentPagination(1)
    }
  }, [window.location.href])

  const [dataPagination, setDataPagination] = useState()

  //lang
  const language = getCookie('lang')
  const word = lang[language]
  const dataCookieFilter = getCookie('project_list_filter_For_api')
  const dataCookieToJson = eval('(' + dataCookieFilter + ')')
  const dataFilterFromSummary = getCookie('data_filter_form_summary')
  const dataCookieFromSummaryToJson = eval('(' + dataFilterFromSummary + ')')

  let dataSortTopOrButtomFormCookie = dataCookieToJson?.dataSortTopOrButtom
  let dataSortByTypeFormCookie = dataCookieToJson?.dataSortByType
  let dataSortTopOrButtom = dataSearch.dataSortTopOrButtom
  let dataSortByType = dataSearch.dataSortByType

  const typeDataSortBy =
    dataSortByType === '1'
      ? 'created_at'
      : dataSortByType === '2'
      ? 'delay'
      : dataSortByType === '3'
      ? 'kickoff'
      : dataSortByType === '4'
      ? 'closure'
      : 'progress'

  const typeDataSortByFormCookie =
    dataSortByTypeFormCookie === '1'
      ? 'created_at'
      : dataSortByTypeFormCookie === '2'
      ? 'delay'
      : dataSortByTypeFormCookie === '3'
      ? 'kickoff'
      : dataSortByTypeFormCookie === '4'
      ? 'closure'
      : 'progress'

  const dataFollow = dataSortTopOrButtom ? 'desc' : 'asc'
  const dataFollowFormCookie = dataSortTopOrButtomFormCookie ? 'desc' : 'asc'

  const paramsType = {
    type: dataCookieToJson?.dataSortByType ? typeDataSortByFormCookie : typeDataSortBy,
    follow: dataCookieToJson?.dataSortTopOrButtom ? dataFollowFormCookie : dataFollow,
  }

  const paramsTypeDefault = {
    type: 'created_at',
    follow: 'desc',
  }

  const onChangeCheckBox = (value) => {
    setValueCheck(!valueCheck)
    if (!value.target.checked) {
      setCheck('N')
    } else {
      setCheck('Y')
    }
  }

  const checkboxApprove = (type) => {
    return (
      <Checkbox
        className="checkbox"
        value={check}
        checked={valueCheck}
        onChange={onChangeCheckBox}
        style={{ alignSelf: type === 'hold' ? 'end' : 'unset' }}
      >
        Require Approval
      </Checkbox>
    )
  }

  const handleCancel = (value) => {
    const data = {
      project_id: parseInt(idProjectSelectMoer),
      remark: value.reason_cancel_form,
    }
    try {
      projectCancel({
        params: data,
        token: token,
      }).then((res) => {
        const { data, status } = res
        if (status === 200) {
          window.location.reload()
        } else if (status === 400) {
          form_cancel.resetFields()
          return Swal.fire('Error', `${data?.errorDesc}`, 'error')
        }
      })
    } catch (error) {
      console.log(error)
    }
    setOpenModalCancleProject(false)
  }

  const handleHold = (value) => {
    let data = {
      project_id: parseInt(idProjectSelectMoer),
      remark: value.reason_hold_form,
      approve: check,
    }
    try {
      projectHold({
        params: data,
        token: token,
      }).then((res) => {
        const { data, status } = res
        if (status === 200) {
          window.location.reload()
        } else if (status === 400) {
          form_hold.resetFields()
          return Swal.fire('Error', `${data?.errorDesc}`, 'error')
        }
      })
    } catch (error) {
      console.log(error)
    }
    setOpenModalHoldProject(false)
  }

  const handleSkip = (value) => {
    const data = {
      project_id: parseInt(idProjectSelectMoer),
      remark: value.reason_cancelApprove_form,
    }
    try {
      projectSkip({
        params: data,
        token: token,
      }).then((res) => {
        const { data, status } = res
        if (status === 200) {
          window.location.reload()
        } else if (status === 400) {
          form_cancelApprove.resetFields()
          return Swal.fire('Error', `${data?.errorDesc}`, 'error')
        }
      })
    } catch (error) {
      console.log(error)
    }
    setOpenModalCancleApprovalProject(false)
  }

  const modalCancel = () => {
    return (
      <Modal
        maskClosable={false}
        className="DeleteModal"
        visible={openModalCancleProject}
        okText={'Confirm'}
        onOk={form_cancel.submit}
        onCancel={() => setOpenModalCancleProject(false)}
        destroyOnClose
      >
        <Form
          className="body-form"
          form={form_cancel}
          onFinish={handleCancel}
          name="form_cancel"
        >
          <CloseCircleOutlined className="CloseCircleOutlined" />
          <h2>{word['btnStatus_title_cancel']}</h2>
          <h4>{word['btnStatus_des_cancel']}</h4>
          <Form.Item
            className="subform"
            id="reason_cancel_form"
            name="reason_cancel_form"
            rules={[
              {
                whitespace: true,
                required: true,
                message: '* Please tell a reason',
              },
            ]}
          >
            <TextArea
              id="reason_cancel"
              name="reason_cancel"
              placeholder="Please tell a reason"
              autoSize={{ minRows: 1, maxRows: 4 }}
            />
          </Form.Item>
        </Form>
      </Modal>
    )
  }

  const modalHold = () => {
    return (
      <Modal
        maskClosable={false}
        className="ModalStatusOption"
        visible={openModalHoldProject}
        okText={'Confirm'}
        onOk={form_hold.submit}
        onCancel={() => setOpenModalHoldProject(false)}
        destroyOnClose
      >
        <Form
          className="body-form"
          form={form_hold}
          onFinish={handleHold}
          name="form_hold"
        >
          <ExclamationCircleOutlined className="exclamationCircleOutlined" />
          <h2>{word['btnStatus_title_hold']}</h2>
          <h4>{word['btnStatus_des_hold']}</h4>
          <Form.Item
            className="subform"
            id="reason_hold_form"
            name="reason_hold_form"
            rules={[
              {
                whitespace: true,
                required: true,
                message: '* Please tell a reason',
              },
            ]}
          >
            <TextArea
              id="reason_hold"
              name="reason_hold"
              placeholder="Please tell a reason"
              autoSize={{ minRows: 1, maxRows: 4 }}
            />
          </Form.Item>
          {checkboxApprove('hold')}
        </Form>
      </Modal>
    )
  }

  const modalSkip = () => {
    return (
      <Modal
        maskClosable={false}
        className="ModalStatusOption"
        visible={openModalCancleApprovalProject}
        onOk={form_cancelApprove.submit}
        okText={'Confirm'}
        cancelText={'Close'}
        onCancel={() => setOpenModalCancleApprovalProject(false)}
        destroyOnClose
      >
        <Form
          name="form_cancelApprove"
          form={form_cancelApprove}
          className="body-form"
          onFinish={handleSkip}
        >
          <ExceptionOutlined className="ExceptionOutlined" />
          <h2>{word['btnStatus_title_skip']}</h2>
          <h4>{word['btnStatus_des_skip']}</h4>
          <Form.Item
            className="subform"
            id="reason_cancelApprove_form"
            name="reason_cancelApprove_form"
            rules={[
              {
                whitespace: true,
                required: true,
                message: '* Please tell a reason',
              },
            ]}
          >
            <TextArea
              id="reason_cancelApprove"
              name="reason_cancelApprove"
              placeholder="Please tell a reason"
              autoSize={{ minRows: 1, maxRows: 4 }}
            />
          </Form.Item>
        </Form>
      </Modal>
    )
  }

  const modalCopy = () => {
    return (
      <ModalCopy
        visibleModalCopy={visibleModalCopy}
        setVisibleModalCopy={setVisibleModalCopy}
        type={'project'}
        id_project={idProject}
        refreshPage={SearchCardlist}
      />
    )
  }

  const SearchCardlist = async (a) => {
    setPathActive('/project-list')
    setWaiting(true)
    let name = dataSearch.project
    let statusSearch = dataSearch.status

    // data for search
    let startDate =
      dataSearch.date === undefined || dataSearch.date === null
        ? ''
        : moment(dataSearch?.date[0]).format('YYYY-MM-DD')
    let endDate =
      dataSearch.date === undefined || dataSearch.date === null
        ? ''
        : moment(dataSearch?.date[1]).format('YYYY-MM-DD')
    let companyId =
      dataSearch.company === null || dataSearch.company === undefined
        ? ''
        : String(dataSearch.company)
    let operationId =
      dataSearch.operation === null || dataSearch.operation === undefined
        ? ''
        : String(dataSearch.operation)
    let suboperationId =
      dataSearch.sub_opearation === null || dataSearch.sub_opearation === undefined
        ? ''
        : String(dataSearch.sub_opearation)
    let projectGroupId =
      dataSearch.project_group_id === null || dataSearch.project_group_id === undefined
        ? ''
        : String(dataSearch.project_group_id)
    let subprojectGroupId =
      dataSearch.subproject_group_id === null ||
      dataSearch.subproject_group_id === undefined
        ? ''
        : String(dataSearch.subproject_group_id)
    let impactTypeId =
      dataSearch.impact_type === null || dataSearch.impact_type === undefined
        ? ''
        : String(dataSearch.impact_type)
    let imperativeIds =
      dataSearch.imperative_ids === null || dataSearch.imperative_ids === undefined
        ? ''
        : String(dataSearch.imperative_ids)
    let delay = dataSearch?.ondelay || dataCookieToJson?.ondelay
    // let delay =
    //   dataSearch.ondelay === null || dataSearch.ondelay === undefined
    //     ? receivedData
    //     : ''

    // data for cookie
    const dataCookieStartDate = dataCookieToJson?.date
    const dataCookieEndDate = dataCookieToJson?.date

    let startDateFormCookie =
      dataCookieStartDate === undefined ||
      dataCookieStartDate === null ||
      dataCookieStartDate === '' ||
      dataCookieStartDate === 'Invalid date'
        ? ''
        : moment(dataCookieStartDate[0]).format('YYYY-MM-DD')
    let endDateFormCookie =
      dataCookieEndDate === undefined ||
      dataCookieEndDate === null ||
      dataCookieEndDate === '' ||
      dataCookieEndDate === 'Invalid date'
        ? ''
        : moment(dataCookieEndDate[1]).format('YYYY-MM-DD')
    let companyIdFormCookie =
      dataCookieToJson?.company === null || dataCookieToJson?.company === undefined
        ? ''
        : String(dataCookieToJson?.company)
    let operationIdFormCookie =
      dataCookieToJson?.operation === null || dataCookieToJson?.operation === undefined
        ? ''
        : String(dataCookieToJson?.operation)
    let suboperationIdFormCookie =
      dataCookieToJson?.sub_opearation === null ||
      dataCookieToJson?.sub_opearation === undefined
        ? ''
        : String(dataCookieToJson?.sub_opearation)
    let projectGroupIdFormCookie =
      dataCookieToJson?.project_group_id === null ||
      dataCookieToJson?.project_group_id === undefined
        ? ''
        : String(dataCookieToJson?.project_group_id)
    let subprojectGroupIdFormCookie =
      dataCookieToJson?.subproject_group_id === null ||
      dataCookieToJson?.subproject_group_id === undefined
        ? ''
        : String(dataCookieToJson?.subproject_group_id)
    let impactTypeIdFormCookie =
      dataCookieToJson?.impact_type === null ||
      dataCookieToJson?.impact_type === undefined
        ? ''
        : String(dataCookieToJson?.impact_type)

    if (dataCookieToJson?.status == undefined) {
      statusSearch = 0
    }

    let status =
      dataSearchURL.status_id == '' || dataSearchURL.status_id == null
        ? dataCookieToJson?.status || ''
        : parseInt(dataSearchURL?.status_id)
    if (dataSearch.project == undefined) {
      name = ''
    }

    let dataArray = ''
    if (a == 3) {
      dataArray = {
        status_list: String(dataSearch.status),
        search: dataSearch.project == null ? '' : dataSearch.project,
        kickoff_start: startDateFormCookie,
        kickoff_end: endDateFormCookie,
        ondelay: delay,
      }
      window.history.pushState('page2', 'Title', `/project-list`)
    } else if (a == 4 || a === undefined) {
      dataArray = {
        status_list:
          dataCookieToJson?.status === null || dataCookieToJson?.status === undefined
            ? ''
            : String(dataCookieToJson?.status),
        search: dataCookieFilter
          ? dataCookieToJson?.project === null
            ? ''
            : dataCookieToJson?.project
          : '',
        kickoff_start: startDateFormCookie,
        kickoff_end: endDateFormCookie,

        company_id: companyIdFormCookie,
        operation_id: operationIdFormCookie,
        suboperation_id: suboperationIdFormCookie,
        project_group_id: projectGroupIdFormCookie,
        subproject_group_id: subprojectGroupIdFormCookie,
        impact_type_id: impactTypeIdFormCookie,
        ondelay: delay,
      }
    } else if (a == 1) {
      dataArray = {
        status_list: String(dataSearch.status),
        search: dataSearch.project == null ? '' : dataSearch.project,
        kickoff_start: startDate,
        kickoff_end: endDate,
        company_id: companyId,
        operation_id: operationId,
        suboperation_id: suboperationId,
        project_group_id: projectGroupId,
        subproject_group_id: subprojectGroupId,
        impact_type_id: impactTypeId,
        imperative_ids: imperativeIds,
        ondelay: delay,
      }
    } else {
      dataArray = {
        search:
          dataSearchURL?.searchvalue != null ? dataSearchURL?.searchvalue : `${name}`,
        status_list:
          status === undefined ? String(dataCookieToJson?.status) : String(status),
        start_date:
          dataSearchURL?.start_date != null
            ? dataSearchURL?.start_date
            : startDateFormCookie,
        end_date:
          dataSearchURL?.end_date != null ? dataSearchURL?.end_date : endDateFormCookie,
        company_id: dataSearchURL?.company_id != null ? dataSearchURL?.company_id : '',
        operation_id:
          dataSearchURL?.operation_id != null ? dataSearchURL?.operation_id : '',
        suboperation_id:
          dataSearchURL?.suboperation_id != null ? dataSearchURL?.suboperation_id : '',
        project_group_id:
          dataSearchURL?.project_group_id != null ? dataSearchURL?.project_group_id : '',
        subproject_group_id:
          dataSearchURL?.subproject_group_id != null
            ? dataSearchURL?.subproject_group_id
            : '',
        impact_type_id:
          dataSearchURL?.impact_type_id != null ? dataSearchURL?.impact_type_id : '',
        ondelay: delay === undefined ? 'n' : delay,
      }
      let dataToSaveCookie = ''
      let dataToSearchApi = ''
      if (dataCookieFromSummaryToJson?.company[0] >= 1) {
        dataToSearchApi = {
          project: null,
          status: String(status),
          date: [
            dataSearchURL?.start_date !== undefined && dataSearchURL?.start_date !== null
              ? dataSearchURL?.start_date
              : startDateFormCookie,
            dataSearchURL?.end_date !== undefined && dataSearchURL?.end_date !== null
              ? dataSearchURL?.end_date
              : endDateFormCookie,
          ],
          company:
            dataCookieFromSummaryToJson.operation[0] !== 'null' &&
            dataCookieFromSummaryToJson.operation[0] !== 'undefined'
              ? []
              : dataCookieFromSummaryToJson.company,
          operation:
            dataCookieFromSummaryToJson.sub_opearation[0] !== 'undefined' &&
            dataCookieFromSummaryToJson.sub_opearation[0] !== 'null'
              ? []
              : dataCookieFromSummaryToJson.operation[0] === 'null' ||
                dataCookieFromSummaryToJson.operation[0] === 'undefined'
              ? []
              : dataCookieFromSummaryToJson.operation,
          sub_opearation:
            dataCookieFromSummaryToJson.sub_opearation[0] === 'null' ||
            dataCookieFromSummaryToJson.sub_opearation[0] === 'undefined'
              ? []
              : dataCookieFromSummaryToJson.sub_opearation,
          project_group:
            dataCookieFromSummaryToJson.subproject_group_id[0] !== 'null' &&
            dataCookieFromSummaryToJson.subproject_group_id[0] !== 'undefined'
              ? []
              : dataCookieFromSummaryToJson.project_group[0] === 'null' ||
                dataCookieFromSummaryToJson.project_group[0] === 'undefined'
              ? []
              : dataCookieFromSummaryToJson.project_group,
          subproject_group_id:
            dataCookieFromSummaryToJson.subproject_group_id[0] === 'undefined' ||
            dataCookieFromSummaryToJson.subproject_group_id[0] === 'null'
              ? []
              : dataCookieFromSummaryToJson.subproject_group_id,
          impact_type:
            dataCookieFromSummaryToJson.impact_type[0] === 'null' ||
            dataCookieFromSummaryToJson.impact_type[0] === 'undefined'
              ? []
              : dataCookieFromSummaryToJson.impact_type,
          dataSortTopOrButtom: true,
          dataSortByType: '1',
          ondelay: 'n',
        }
        dataToSaveCookie = {
          project: null,
          status: String(status),
          date: [
            dataSearchURL?.start_date !== undefined && dataSearchURL?.start_date !== null
              ? dataSearchURL?.start_date
              : startDateFormCookie,
            dataSearchURL?.end_date !== undefined && dataSearchURL?.end_date !== null
              ? dataSearchURL?.end_date
              : endDateFormCookie,
          ],
          company: dataCookieFromSummaryToJson.company,
          operation:
            dataCookieFromSummaryToJson.operation[0] === 'null'
              ? []
              : dataCookieFromSummaryToJson.operation,
          sub_opearation:
            dataCookieFromSummaryToJson.sub_opearation[0] === 'null'
              ? []
              : dataCookieFromSummaryToJson.sub_opearation,
          project_group:
            dataCookieFromSummaryToJson.project_group[0] === 'null'
              ? []
              : dataCookieFromSummaryToJson.project_group,
          impact_type:
            dataCookieFromSummaryToJson.impact_type[0] === 'null'
              ? []
              : dataCookieFromSummaryToJson.impact_type,
          subproject_group_id:
            dataCookieFromSummaryToJson.subproject_group_id[0] === 'null'
              ? []
              : dataCookieFromSummaryToJson.subproject_group_id,
          dataSortTopOrButtom: true,
          dataSortByType: '1',
          ondelay: false,
        }
      } else {
        dataToSaveCookie = {
          project: null,
          status:
            status === undefined ? String(dataCookieToJson?.status) : String(status),
          date: [
            dataSearchURL?.start_date !== undefined && dataSearchURL?.start_date !== null
              ? dataSearchURL?.start_date
              : startDateFormCookie,
            dataSearchURL?.end_date !== undefined && dataSearchURL?.end_date !== null
              ? dataSearchURL?.end_date
              : endDateFormCookie,
          ],
          company: [],
          operation: [],
          sub_opearation: [],
          project_group: [],
          impact_type: [],
          subproject_group_id: [],
          dataSortTopOrButtom: true,
          dataSortByType: '1',
          ondelay: false,
        }
        dataToSearchApi = {
          project: null,
          status:
            status === undefined ? String(dataCookieToJson?.status) : String(status),
          date: [
            dataSearchURL?.start_date !== undefined && dataSearchURL?.start_date !== null
              ? dataSearchURL?.start_date
              : startDateFormCookie,
            dataSearchURL?.end_date !== undefined && dataSearchURL?.end_date !== null
              ? dataSearchURL?.end_date
              : endDateFormCookie,
          ],
          company: [],
          operation: [],
          sub_opearation: [],
          project_group: [],
          impact_type: [],
          subproject_group_id: [],
          dataSortTopOrButtom: true,
          dataSortByType: '1',
          ondelay: 'n',
        }
      }

      if (dataToSaveCookie.date[0]) {
        setCookie('project_list_filter', dataToSaveCookie)
        setCookie('project_list_filter_For_api', dataToSearchApi)
        window.history.back()
        window.location.href = '/project-list'
      }
    }
    setDataPagination(dataArray)

    try {
      await getSearchCardlist({
        limit: initalState.limit,
        page: initalState.page,
        params: dataArray,
        token: token,
        sortBy: dataCookieToJson === undefined ? paramsTypeDefault : paramsType,
      }).then((response) => {
        const { status, data, error } = response
        if (error) {
          setData([])
          setRender(0)
        }
        if (status === 200) {
          setData(data.data)
          setWaiting(false)
          setTotalRecord(data.total_record)
          setTotalPage(data.total_page)
          setRender(1)
        } else {
          setRender(0)
          setData([])
        }
      })
    } catch (error) {
      setRender(0)
      setData([])
      console.log(error)
    }
  }

  const goEditProject = (data) => {
    setCookie('wordLine', '')
    setCookie('companyId_project', data.company_id)
    localStorage.setItem('activeProjectTab', '2')
    history.push({
      pathname: `/project/${data.id}/edit`,
      search: '?returnTo=project-card',
    })
  }
  const goOverView = (data) => {
    history.push(`overview/${data.id}`)
  }
  const goActivity = (data) => {
    history.push(`activity/${data.id}`)
  }
  const goReschedule = (data) => {
    history.push(`reschedule/${data.id}`)
  }
  const goProjectProgressUpdate = (data) => {
    history.push(`project/${data.id}/quick-update`)
  }

  const handleCopyProject = (data) => {
    setIdProject(data.id)
    setVisibleModalCopy(true)
  }

  const handleDelete = () => {
    try {
      deleteProject({
        project_id: idProject,
        token: token,
      }).then((res) => {
        if (res.status === 200) {
          SearchCardlist()
          setCurrentPagination(1)
        }
      })
    } catch (error) {
      console.log(error)
    }
    setVisibleModalDelete(false)
  }

  const modalDelete = () => {
    return (
      <Modal
        maskClosable={false}
        className="DeleteModal"
        visible={visibleModalDelete}
        okText={'Delete'}
        onOk={handleDelete}
        onCancel={() => setVisibleModalDelete(false)}
      >
        <CloseCircleOutlined className="CloseCircleOutlined" />
        <h2>{word['btnStatus_title_delete']}</h2>
        <h4>{word['btnStatus_des_delete']}</h4>
      </Modal>
    )
  }

  useEffect(() => {
    setCookie('idPRJ', '')
  }, [])

  // saved = 2
  // Registered = 4
  // Kicked off = 6
  // On hold = 7
  // Completed = 9
  // Completed with Delay = 21
  // Cancelled = 19
  // Waiting for approve (Register) = 3
  // Waiting for approve (Kick off) = 5
  // Waiting for approve (On hold) = 28
  // Waiting for approve (Complete) = 8

  const onCancelProject = (id) => {
    setIdProjectSelectMoer(id)
    setOpenModalCancleProject(true)
  }

  const onHoldProject = (id) => {
    setIdProjectSelectMoer(id)
    setOpenModalHoldProject(true)
  }
  const onCancleApproval = (id) => {
    setIdProjectSelectMoer(id)
    setOpenModalCancleApprovalProject(true)
  }

  const menu = (data) => {
    return (
      <Menu style={{ minWidth: '180px' }}>
        <Menu.Item key="0" onClick={() => goEditProject(data)}>
          {word['Edit']}
        </Menu.Item>
        {/* Edit onclick */}
        <Menu.Item
          key="Project_Progress_Update"
          onClick={() => goProjectProgressUpdate(data)}
        >
          {word['Project_Progress_Update']}
        </Menu.Item>
        <Menu.Item key="1" onClick={() => goOverView(data)}>
          {word['View']} {word['Overview']}
        </Menu.Item>
        <Menu.Item key="2" onClick={() => goActivity(data)}>
          {word['Project_Activity']}
        </Menu.Item>
        <Menu.Item
          hidden={permission.update ? false : true}
          onClick={() => goReschedule(data)}
        >
          {word['Reschedule']}
        </Menu.Item>
        <Menu.Item
          hidden={permission.create ? false : true}
          key="3"
          onClick={() => handleCopyProject(data)}
        >
          {word['Copy']}
        </Menu.Item>
        <Menu.Item
          key="5"
          hidden={
            data.status_id === 4 ||
            data.status_id === 6 ||
            data.status_id === 7 ||
            data.status_id === 3 ||
            data.status_id === 5 ||
            data.status_id === 28 ||
            data.status_id === 8
              ? permission.update
                ? false
                : true
              : true
          }
          onClick={() => onCancelProject(data.id)}
        >
          {word['CancelProject']}
        </Menu.Item>
        <Menu.Item
          key="6"
          hidden={data.status_id === 6 ? (permission.update ? false : true) : true}
          onClick={() => onHoldProject(data.id)}
        >
          {word['Hold']}
        </Menu.Item>
        <Menu.Item
          hidden={
            !(
              (permission.delete && data.status_id === 2) ||
              (permission.delete && permission.menu_id === 3) ||
              (permission.delete && permission.menu_id === 25) ||
              roleUser === 1
            )
          }
          onClick={() => {
            setVisibleModalDelete(true)
            setIdProject(data.id)
          }}
          key="4"
        >
          {word['Delete']}
        </Menu.Item>
        <Menu.Item
          key="7"
          hidden={
            data.status_id === 3 ||
            data.status_id === 5 ||
            data.status_id === 28 ||
            data.status_id === 8
              ? permission.update
                ? false
                : true
              : true
          }
          onClick={() => onCancleApproval(data.id)}
        >
          {word['CancelApproval']}
        </Menu.Item>
      </Menu>
    )
  }

  const onChangePage = async (page) => {
    setCurrentPagination(page)
    await getSearchCardlist({
      limit: initalState?.limit,
      page: page,
      params: dataPagination,
      token: token,
      sortBy: dataCookieToJson === undefined ? paramsTypeDefault : paramsType,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          await setData([])
          return true
        }
        if (status === 200) {
          await setData(data.data)
          window.scrollTo(0, 0)
        } else {
          setData([])
          return true
        }
      })
      .catch((error) => {
        setData([])
        console.error(error)
      })
  }
  const tagProgress = (val) => {
    return (
      <>
        <Row>
          <div
            className={`percent-text ${
              val.done_percent < 75 && val.done_percent !== 0
                ? 'percent-reject'
                : val.done_percent === 100
                ? 'percent-green'
                : val.done_percent === 0
                ? 'percent-zero'
                : 'percent-yellow'
            }`}
          >
            {val.done_percent}%
          </div>
        </Row>
        <Row className="row col-style ">
          <Progress
            style={{
              width: '100%',
            }}
            strokeColor={
              val.done_percent < 75 && val.done_percent !== 0
                ? color.percent_50
                : val.done_percent === 100
                ? color.percent_100
                : val.done_percent === 0
                ? color.percent_0
                : color.percent_75
            }
            percent={val.done_percent}
            showInfo={false}
          />
        </Row>
      </>
    )
  }
  const checkPagination = (totalPage) => {
    if (totalPage !== 1) {
      return (
        <Pagination
          className="pagination"
          current={currentPagination}
          defaultCurrent={initalState?.current}
          total={totalRecord}
          pageSize={initalState?.limit}
          onChange={onChangePage}
          showSizeChanger={false}
          showQuickJumper
        />
      )
    }
  }

  const renderCardList = () => {
    const mapData = dataList.map((val, index) => {
      return (
        <div className="container-card-div">
          <Row key={index} className="rowcard-container">
            <Col className="colcard-container">
              <div
                className={`status-bar ${
                  val.status_id === 2
                    ? 'status-draft'
                    : val.status_id === 3
                    ? 'status-waiting-register'
                    : val.status_id === 4
                    ? 'status-register'
                    : val.status_id === 5
                    ? 'status-waiting-kickoff'
                    : val.status_id === 6
                    ? 'status-kickoff'
                    : val.status_id === 7
                    ? 'status-hold'
                    : val.status_id === 8
                    ? 'status-waiting-complete'
                    : val.status_id === 9
                    ? 'status-complete'
                    : val.status_id === 21
                    ? 'status-complete-delay'
                    : val.status_id === 28
                    ? 'status-waiting-hold'
                    : 'status-cancel'
                }`}
              >
                <div>{val.status}</div>
              </div>
              <div className="gutter-row " style={style}>
                <Row className="row col-style">
                  <div className="column-diflex">
                    <Col className="img-col">
                      <img
                        style={{ cursor: 'pointer' }}
                        onClick={() => goOverView(val)}
                        className="logo"
                        src={val?.logo === null ? imgDefault : val?.pic_display}
                      />
                    </Col>

                    <Col className="text-col">
                      <Row align="middle" style={{ flexWrap: 'nowrap' }}>
                        <div style={{ display: 'grid' }}>
                          <h4
                            className="cutter-text-line-1"
                            style={{ cursor: 'pointer' }}
                            onClick={() => goEditProject(val)}
                          >
                            {val.name}
                          </h4>
                        </div>
                        {val.complete_flow === 'N' ? (
                          <Tooltip title={'Incomplete Sprint Task'}>
                            <ExclamationCircleOutlined className="icon-exclamation" />
                          </Tooltip>
                        ) : (
                          ''
                        )}
                      </Row>
                      <div style={{ display: 'grid' }}>
                        {val.description != '' && val.description != undefined ? (
                          <TextSeeMore
                            text={val.description}
                            titleModal={'Project Description'}
                          />
                        ) : (
                          <span className="small cutter-text-line-multi-3"></span>
                        )}
                      </div>
                    </Col>
                  </div>
                  <Col className="more-col" style={{ minWidth: 'fit-content' }}>
                    <Dropdown
                      overlay={(e) => menu(val)}
                      trigger={['click']}
                      placement="bottomRight"
                      overlayStyle={{ minWidth: '180px' }}
                    >
                      <a
                        className="ant-dropdown-link"
                        onClick={(e) => e.preventDefault()}
                      >
                        <img src={more} />
                      </a>
                    </Dropdown>
                  </Col>
                </Row>
                {tagProgress(val)}
                <Row className="row-shortcompanyand-date">
                  <span className="shortname-company cutter-text-line-1 ">
                    {val?.company_short_name || val?.company_name_en}
                  </span>
                  {val.status_id !== 19 && (
                    <span
                      className={`left-time ${
                        (val.status_id === 21 || val.status_id === 9) &&
                        (val.schedule_deviation > 10 || val.schedule_deviation < -10)
                          ? 'status-Cancel-color'
                          : (val.status_id === 21 || val.status_id === 9) &&
                            (val.schedule_deviation <= 10 ||
                              val.schedule_deviation >= -10)
                          ? 'status-Done-color'
                          : val.status_id !== 21 &&
                            val.status_id !== 9 &&
                            val.day_left <= 7
                          ? 'status-Cancel-color'
                          : 'status-Done-Delayed-color'
                      }`}
                    >
                      {val.status_id === 21 || val.status_id === 9
                        ? `SD: ${val.schedule_deviation}%`
                        : `${val.day_left} days left`}
                    </span>
                  )}
                </Row>
                <Row
                  className="row-user"
                  style={{ flexWrap: 'nowrap', alignItems: 'center' }}
                >
                  <Col className="user-col">
                    <UserOutlined style={{ color: '#7C7C84' }} className="user-icon" />
                    <div style={{ display: 'grid', paddingRight: 16 }}>
                      <span className="user-name small cutter-text-line-1">
                        {val.firstname} {val.lastname}
                      </span>
                    </div>
                  </Col>

                  <Col className="date-col" style={{ minWidth: 'fit-content' }}>
                    <div className="date-text">
                      <CalendarOutlined className="user-icon" />
                      <span className="small">
                        {moment(val.kickoff).format('DD MMM YYYY')} -{' '}
                        {moment(val.closure).format('DD MMM YYYY')}
                      </span>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      )
    })
    return mapData
  }

  if (render === 1) {
    return (
      <>
        <Container className="container-card-project">
          {waiting === true ? (
            <div className="projectlist-style-loading ">
              <img className="robot" src={loadingSvg}></img>
              <img src={loadingAnimationSvg}></img>
            </div>
          ) : (
            <div className="list-response-height">
              <Row justify="start" className="row">
                {renderCardList()}
              </Row>
            </div>
          )}

          {waiting === false ? checkPagination(totalPage) : ''}

          {modalCopy()}
          {modalDelete()}
          {modalCancel()}
          {modalHold()}
          {modalSkip()}
        </Container>
      </>
    )
  } else {
    return (
      <Container className="container-card-project">
        <div className="empty-container edit-padding">
          <InboxOutlined className="InboxOutlined" />
          <h1>
            {word['no_data']} {word['Project']}
          </h1>
        </div>
      </Container>
    )
  }
}

export default CardListComponents
